import React from "react";
import { Col, Form } from "react-bootstrap";
import { CondicionPago } from "models/ECF/CondicionPago";
import { SideInput } from "components/Inputs/SideBar/SideInput";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import RadioGroup from "components/RadioGroup/RadioGroup";

const CondicionPagoEdit = ({ condicionPago, setCondicionPago }) => {
  return condicionPago !== undefined &&
    (
      <Col>
        <Form
          action=""
          className="form-horizontal"
          id="TypeValidation"
          method="">

          <SideInput
            label="Descripción"
            name="Descripcion"
            type="text"
            value={condicionPago?.Descripcion || ""}
            setState={setCondicionPago}
            required
          />

          <SideInput
            label="Días"
            name="Dias"
            type="number"
            min={0}
            value={condicionPago?.Dias || 0}
            setState={setCondicionPago}
            required />

          <InputContainer stacked label="Estatus" labelClassName={"d-flex"}>
            <RadioGroup
              name="Estatus"
              options={CondicionPago.ESTATUS_LIST}
              selectedOption={condicionPago?.Estatus || CondicionPago.ESTATUS_ACTIVO}
              onChange={(e) => setCondicionPago({ ...condicionPago, Estatus: e.target.value })}
              disabled={!condicionPago?.IdSec}
            />
          </InputContainer>
        </Form>
      </Col>
    )
};
export default CondicionPagoEdit;
